import { Button, Card, Icon, Tooltip } from "../../common/HarmonyEnablers";
import "./Card.css";

const CardComponent_Interactive_Bigger = (props: any) => {
  return (
    <a href={props.titlelink} target="_blank" className="no-underline"
      aria-label={props.title || "Navigate to tutorial video"}
      title={props.title || "Navigate to tutorial video"}>
      <div className="container-card-bigger">
        <div className="inner-container-card2">
          <div className="imageholder-card2">
            <img src={props.imageSrc} alt={props.imageAlt || props.title || "image"} />
          </div>
          <div className="textholder-card2">
            <div className="headingText">{props.title}</div>
            <div className="subtitle-cropped" id={props.title}>{props.subtitle}</div>
            <Tooltip anchor={props.title} placement="start">
              {props.subtitle}
            </Tooltip>
          </div>
        </div>
      </div>
    </a>
  );
};

export { CardComponent_Interactive_Bigger };
